import React, { useContext } from 'react';
import { useCardIcon, useMediaQuery } from 'libs';
import { AppDataContext } from 'contexts/appData';

import { ReactComponent as ErrorInfo } from 'resources/img/icons/error-info.svg';
import { ReactComponent as ArrowDown } from 'resources/img/icons/arrow_back_ios.svg';
import clsx from 'clsx';
import { usePaymentContext } from '../PaymentProvider';

export const PaymentSavedCard = ({ card, isSelected, onChange, onCardChange, isExpired }) => {
  const { langs } = useContext(AppDataContext);
  const { cardSelection, selectedCard, setSelectedCard, cards } = usePaymentContext();
  const { getCardIcon } = useCardIcon();
  const CardIcon = getCardIcon(card?.card_mask);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const cardMask = card?.card_mask?.replace(/\D/g, '*');

  if (card) {
    return (
      <div className="mb-8px cursor-pointer">
        <div
          className={clsx('custom-control custom-radio border-radius-md py-20px px-16px py-md-24px px-md-24px m-auto', {
            active: !cardSelection.isOpen && isSelected,
            'active-without-hover': cardSelection.isOpen && isSelected,
          })}
          onClick={onChange}
        >
          <div className="d-flex align-items-center justify-content-between h-48px h-md-24px">
            <label className={clsx('custom-control-label mr-24px', { active: isSelected })}>
              <CardIcon className="mr-14px" />
              <div className={clsx('font-bold font-size-12 font-size-md-14 text-text-black', { isExpired: 'opacity-40' })}>
                {/*{card.card_mask.slice(-8)}*/}
                {isMobile ? cardMask.slice(-8) : cardMask}
              </div>
              {isExpired && <ErrorInfo className="ml-12px" />}
            </label>
            {(isSelected || isExpired) && (
              <div className="d-flex align-items-center justify-content-center" onClick={onCardChange}>
                <div className="clamp _2 font-medium font-size-12" style={{ color: '#006AFF', userSelect: 'none' }}>
                  {langs.NM_ChangeCard}
                </div>
                <ArrowDown className={clsx('ml-8px flex flex-shrink-0 transition-rotate', { 'rotate-180': cardSelection.isOpen })} />
              </div>
            )}
          </div>

          {cardSelection.isOpen && (
            <div className="mt-16px payment-modal-options-grid">
              {cards.map((card) => {
                const isActive = selectedCard.uuid === card.uuid;
                const CardIcon = getCardIcon(card?.card_mask);
                const cardMask = card?.card_mask?.replace(/\D/g, '*');
                return (
                  <div
                    key={card.uuid}
                    className={clsx('py-16px px-12px py-md-20px px-md-20px border-radius-12 payment-modal-option', { active: isActive })}
                    onClick={() => setSelectedCard(cards.find((el) => el.uuid === card.uuid))}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center gap-8px">
                        <div className='w-50px'>
                          <CardIcon />
                        </div>
                        <div className="hidden-on-desktop font-bold font-size-12 font-size-md-14" style={{ color: '#222' }}>
                          {/*{card.card_mask.slice(-8)}*/}
                          {cardMask}
                        </div>
                      </div>
                      <div className={clsx('payment-checkbox', { checked: isActive })}></div>
                    </div>
                    <div className="hidden-on-mobile font-bold font-size-12 font-size-md-14 mt-12px" style={{ color: '#222' }}>
                      {/*{card.card_mask.slice(-8)}*/}
                      {cardMask}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
};
